var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pending-wrapper"},[(_vm.pending !== 1)?_c('div',{staticClass:"result-box"},[_vm._m(0)]):_vm._e(),_c('popupBottom',_vm._b({attrs:{"open":_vm.resultPopup.visible}},'popupBottom',_vm.resultPopup,false))],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-box"},[_c('i',{staticClass:"el-icon-loading custom_loading"})])
}]

export { render, staticRenderFns }